export default {
  bc_lib_site: 'Core subdomain',
  bw_card_featured: 'Web featured card',
  bw_card_evergreen: 'Web evergreen card',
  bw_post_date: 'Web post date',
  bw_card_end_time: 'Web expiration date',
  bw_post_tag: 'Web post tag',
  cic_keywords: 'Card keywords',
  bw_tax_audiences: 'Web audience taxonomy mapping',
  bw_tax_formats: 'Web format taxonomy mapping',
  bw_tax_super_formats: 'Web super format taxonomy mapping',
  bw_tax_topic: 'Web topic taxonomy: Web subject taxonomy mapping',
  bw_tax_genre: 'Web genre taxonomy',
  bw_tax_genre__forms: 'Web genre taxonomy mapping',
  bw_tax_content_type: 'Web content type',
  core_metadata_ids: 'Metadata IDs',
  core_authors: 'Resource author',
  core_subject__headings: 'Resource subject',
  core_formats: 'Resource format',
  core_super_formats: 'Resource super format',
  core_genre__forms: 'Resource genre',
  core_list_metadata_ids: 'List metadata ID',
  core_list_authors: 'List resource author',
  core_list_subject__headings: 'List resource subject',
  core_list_genre__forms: 'List resource genre',
  core_list_anchor_metadata_id: 'List anchor resource',
  core_list_anchor_authors: 'List anchor resource author',
  core_list_anchor_subject__headings: 'List anchor resource subject',
  core_list_anchor_genre__forms: 'List anchor resource genre',
  events_metadata_ids: 'Event metadata ID',
  events_authors: 'Event author',
  events_subject__headings: 'Event subject',
  events_genre__forms: 'Event genre',
  card_id: 'Card ID',
  confidence: 'Confidence',
  score: 'Score'
};
